<template>
  <div>
    <v-card class="ma-2 white rounded-lg">
      <v-card-title class="secondary--text">لیست کسب و کار حسابداری ابری</v-card-title>

      <v-card-text>
        <div>
          <m-datatable
            :show-select="false"
            :show-filter-row="false"
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
          >
            <template #item.superuser="{ item }">
              <v-row v-if="item.superuser" no-gutters class="text-right">
                <v-col v-for="(i, idx) in filteredSurvey(item.superuser.survey)" :key="idx" cols="12">
                  {{ i.question }} :
                  <span v-if="Array.isArray(i.answer)">
                    {{ i.answer.join(", ") }}
                  </span>
                  <span v-else>{{ i.answer }}</span>
                </v-col>
              </v-row>
            </template>
          </m-datatable>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CloudAccounting",
  data() {
    return {
      filters: {},
      allowedQuestions: [
        "تیم شما چند نفره است؟",
        "با حسابداری چقدر آشنایی دارید؟",
        "در حال حاضر حسابداری کسب و کار خود را چگونه انجام میدهید؟",
        "بزرگ‌ترین چالش‌های فعلی شما کدام هستند؟",
      ],
    };
  },
  computed: {
    url() {
      return "sobhanAdmin/companies/needs-accountant/";
    },
    headers() {
      return [
        {
          text: "ID",
          value: "id"
        },
        {
          text: "نام کسب و کار",
          value: "name"
        },
        {
          text: "مدیر کسب و کار",
          value: "created_by"
        },
        {
          text: "شماره تماس",
          value: "superuser.phone"
        },
        {
          text: "تاریخ عضویت",
          value: "created_at",
          filterable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[0];
          },
        },
        {
          text: "ساعت عضویت",
          value: "time",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[1];
          },
        },
        {
          text: "اطلاعات کسب و کار",
          value: "superuser",
          width: "600px"
        },
      ];
    },
  },
  methods: {
    filteredSurvey(survey) {
      if (!survey) return [];
      return survey.filter((q) => this.allowedQuestions.includes(q.question));
    },
  },
};
</script>
